module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0020.0f3087fb.jpg";